export const selectConfig = (state) => state.config

export const selectIsProd = (state) => {
  const brooklyn = state.config.getIn(['data', 'servers', 'brooklyn'], '')
  return !brooklyn.includes('stage')
}

export const selectBrooklynServerUrl = (state) => {
  const url = state.config.getIn(['data', 'servers', 'brooklyn'], '')
  const isLoading = state.config.get('processing')
  return {
    isLoading,
    url,
  }
}

export const selectGraphqlServerUrl = (state) => {
  const url = state.config.getIn(['data', 'servers', 'graphql'], '')
  const isLoading = state.config.get('processing')
  return {
    isLoading,
    url,
  }
}
export const selectRefundEndEntitlementsFeatureFlag = (state) => {
  const featureFlagRefundEndEntitlements = state.config.getIn(
    ['data', 'features', 'refundEndEntitlements'],
    true,
  )
  const isLoading = state.config.get('processing')
  return {
    isLoading,
    featureFlagRefundEndEntitlements,
  }
}
